/* eslint-disable @typescript-eslint/naming-convention */
import {DialogBackdrop} from './Backdrop/DialogBackdrop.tsx'
import {DialogPortal} from './Portal/DialogPortal.tsx'
import {DialogRoot} from './Root/DialogRoot.tsx'
import {DialogPopup} from './Popup/DialogPopup.tsx'
import {DialogTitle} from './Title/DialogTitle.tsx'
import {DialogDescription} from './Description/DialogDescription.tsx'

export namespace Dialog {
    export const Root = DialogRoot
    export const Portal = DialogPortal
    export const Backdrop = DialogBackdrop
    export const Popup = DialogPopup
    export const Title = DialogTitle
    export const Description = DialogDescription
}
